import Row from 'components/Panel/Row';
import { ExamsValidDateMsg, OnlinePaymentDiscountAdvertMsg } from 'components';

import { Divider } from '@britishcouncil/react-solas-ors3';

type TotalFeeProps = {
  fee: string;
};

const TotalFee = ({ fee }: TotalFeeProps) => {
  return (
    <>
      <Divider />
      <h2>Payment</h2>
      <ExamsValidDateMsg />
      <Row>
        <span>
          Fee:&nbsp;
          <b>{fee}</b>
        </span>
      </Row>
      <OnlinePaymentDiscountAdvertMsg />
    </>
  );
};

export default TotalFee;
